import React, { Fragment } from 'react';
import { Intro, MultipleChoice } from 'abbot-core';
import img from '../../assets/images/U1-T2-1-3.svg';
// import questionVO from '../../assets/vo/U1-T2-1-3.mp3';

const data = {
  inputType: 'checkbox',
  question: 'Which of the following are types of foods that can help keep you healthy? Select ALL that apply.',
  options: [
    {
      label: 'whole grain breads and cereals'
    },
    {
      label: 'leafy green vegetables'
    },
    {
      label: 'french fries'
    },
    {
      label: 'grilled chicken breast'
    },
    {
      label: 'bag of pretzels'
    },
  ]
};

const feedback = {
  success: {
    title: 'That’s right.',
    body: 'There are many types of foods that can help you stay healthy. You’ll learn more in the module.'
  },
  error: {
    title: 'Not quite.',
    body: `There are many types of foods that can help you stay healthy. You’ll learn more in the module.`
  }
};

const correctInput = {
  [data.question]: [
    data.options[0].label,
    data.options[1].label,
    data.options[3].label
  ]
};

export default {
  title: 'Question 1',
  path: '/prepare/question-1',
  content: (
    <Fragment>
      <Intro
        title="Show What You Know"
        direction="Select the best answer to each question."
        img={img}
      />

      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/prepare/Question1.js